<shared-medical-component-search
  [addOffset]="data.element?.elementType === FlowchartElementType.FlowchartDecisionNode"
  [filterOptions]="searchOptions"
  [isDialog]="false"
  (selectedComponent)="selectedComponent($event)" />

@if (data.element?.elementType === FlowchartElementType.FlowchartDecisionNode) {
  <mat-icon
    class="rule"
    ttTooltip="{{ 'selectRule' | transloco }}"
    [icon]="'chevrons-left-right'"
    [iconSize]="18"
    (click)="openRuleDialog($event)"
    >code</mat-icon
  >
}
